import { FileWithPreview } from 'react-dropzone';

export const HIDE_IMAGE_UPLOADER_LOADER = 'HIDE_IMAGE_UPLOADER_LOADER';
export type HIDE_IMAGE_UPLOADER_LOADER = typeof HIDE_IMAGE_UPLOADER_LOADER;

export interface HideImageUploaderLoaderAction {
    type: HIDE_IMAGE_UPLOADER_LOADER;
    resourcesId: string;
}

export function hideImageUploaderLoader(resourcesId: string): HideImageUploaderLoaderAction {
    return {
        type: HIDE_IMAGE_UPLOADER_LOADER,
        resourcesId
    };
}

export const SHOW_IMAGE_UPLOADER_LOADER = 'SHOW_IMAGE_UPLOADER_LOADER';
export type SHOW_IMAGE_UPLOADER_LOADER = typeof SHOW_IMAGE_UPLOADER_LOADER;

export interface ShowImageUploaderLoaderAction {
    type: SHOW_IMAGE_UPLOADER_LOADER;
    resourcesId: string;
}

export function showImageUploaderLoader(resourcesId: string): ShowImageUploaderLoaderAction {
    return {
        type: SHOW_IMAGE_UPLOADER_LOADER,
        resourcesId
    };
}

export const UPLOAD_IMAGE_UPLOADER_IMAGE = 'UPLOAD_IMAGE_UPLOADER_IMAGE';
export type UPLOAD_IMAGE_UPLOADER_IMAGE = typeof UPLOAD_IMAGE_UPLOADER_IMAGE;

export interface UploadImageUploaderImageAction {
    type: UPLOAD_IMAGE_UPLOADER_IMAGE;
    files: FileWithPreview[];
    paramsId: string;
}

export function uploadImageUploaderImage(files: FileWithPreview[], paramsId: string): UploadImageUploaderImageAction {
    return {
        type: UPLOAD_IMAGE_UPLOADER_IMAGE,
        files,
        paramsId
    };
}

export const UPLOAD_IMAGE_UPLOADER_IMAGE_SUCCESS = 'UPLOAD_IMAGE_UPLOADER_IMAGE_SUCCESS';
export type UPLOAD_IMAGE_UPLOADER_IMAGE_SUCCESS = typeof UPLOAD_IMAGE_UPLOADER_IMAGE_SUCCESS;

export interface UploadImageUploaderImageSuccessAction {
    type: UPLOAD_IMAGE_UPLOADER_IMAGE_SUCCESS;
    imageUrl: string;
    resourcesId: string;
}

export function uploadImageUploaderImageSuccess(
    imageUrl: string,
    resourcesId: string
): UploadImageUploaderImageSuccessAction {
    return {
        type: UPLOAD_IMAGE_UPLOADER_IMAGE_SUCCESS,
        imageUrl,
        resourcesId
    };
}

export const INIT_IMAGE_UPLOADER = 'INIT_IMAGE_UPLOADER';
export type INIT_IMAGE_UPLOADER = typeof INIT_IMAGE_UPLOADER;

export interface InitImageUploaderAction {
    type: INIT_IMAGE_UPLOADER;
    imageUrl: string;
    resourcesId: string;
}

export function initImageUploader(imageUrl: string, resourcesId: string): InitImageUploaderAction {
    return {
        type: INIT_IMAGE_UPLOADER,
        imageUrl,
        resourcesId
    };
}

export const RESET_IMAGE_UPLOADER_CHANGES = 'RESET_IMAGE_UPLOADER_CHANGES';
export type RESET_IMAGE_UPLOADER_CHANGES = typeof RESET_IMAGE_UPLOADER_CHANGES;

export interface ResetImageUploaderChangesAction {
    type: RESET_IMAGE_UPLOADER_CHANGES;
    resourcesId: string;
}

export function resetImageUploaderChanges(resourcesId: string): ResetImageUploaderChangesAction {
    return {
        type: RESET_IMAGE_UPLOADER_CHANGES,
        resourcesId
    };
}

export type ImageUploaderAction =
    | HideImageUploaderLoaderAction
    | ResetImageUploaderChangesAction
    | InitImageUploaderAction
    | ShowImageUploaderLoaderAction
    | UploadImageUploaderImageAction
    | UploadImageUploaderImageSuccessAction;
